import type * as ents from '@attain-apps/entities'
import * as store from '@attain-apps/fe/web/main/lib/store'

import { State } from './state'

/**
 * Core actions for this feature
 */
// NOTE: intentionally missing return type so that type can be inferred
export function getActionsConfig() {
  return {
    putAlias: store.actions.standalone({
      data: store.actions.Data.asIs<
        ExactlyOneOf<{
          widget?: Pick<ents.core.mosaic.Widget.Rendering, 'alias' | 'id'>
        }>
      >(),
      reducer: ({ data: { widget }, state }) => {
        if (widget) {
          const { alias, id } = widget

          if (id && alias) {
            state = State.Lookup.put(
              { lookupName: 'widgetAliasLookup', state },
              { alias, id },
            )
          }
        }

        return state
      },
    }),
    reset: store.actions.standalone({
      data: store.actions.Data.NONE,
      reducer: () => State.INITIAL,
    }),
  } as const satisfies store.actions.Config.Constraint<State>
}
